namespace Areas.Inspectors.Index {
    "use strict";

    var inspectorAssignmentTabItems = Areas.createTabsWithSameAction("Inspectors", "Index",
        ["UnAssigned", "ReAssigned", "Return"])

    var scheduledInspectionsTabItems = Areas.createTabsWithSameController("Inspectors",
        ["IndexMy", "IndexAll"], "Scheduled");

    var deputyInspectionsTabItems = Areas.createTabsWithSameController("Inspectors",
        ["IndexMy", "Index"], "Deputy");
    

    export function inspectorAssignmentTabInitialized(params: any) {
        return Areas.tabInitialized(inspectorAssignmentTabItems)(params);
    }

    export function scheduledInspectionsTabInitialized(params: any) {
        return Areas.tabInitialized(scheduledInspectionsTabItems)(params);
    }

    export function deputyInspectionsTabInitialized(params: any) {
        return Areas.tabInitialized(deputyInspectionsTabItems)(params);
    }
}